import { BRAND } from '@/constants/brand';
import { APP_SHELL_THEME } from '@/styles/appShellTheme';

/** Skyrise-branded dark dashboard palette for forecasting pages. */
export const FORECASTING_THEME = {
  ...APP_SHELL_THEME,
  forecast: BRAND.hacienda,
  booked: BRAND.casa,
  pipe: BRAND.padilla,
  kpiDynamicBorder: BRAND.hacienda,
  kpiBudgetBorder: BRAND.casa,
  kpiVsBorder: BRAND.lavanda,
  accentOrange: BRAND.hacienda
} as const;

export const STAGE_COLORS = {
  Forecast: FORECASTING_THEME.forecast,
  Booked: FORECASTING_THEME.booked,
  Pipe: FORECASTING_THEME.pipe,
  Other: BRAND.lavanda
} as const;
